/**
 * 绶带-卡牌
 * Create by liaokai on 2020-04-20 16:25:44
 */
import * as React from 'react';
import {Component} from "react";
// @ts-ignore
import leftImg from "../../../../../assets/ribbon-left.png"
// @ts-ignore
import rightImg from "../../../../../assets/ribbon-right.png"
import style from "./ribbon.scss"

interface IProps{

}

interface IState{

}

export class Ribbon extends Component<IProps,IState>{
    readonly state : IState = {

    };
    render() {
        let {children} = this.props;
        let {} = this.state;
        return (
            <div className={style.container}>
                <div className={style.leftBox}>
                    <img src={leftImg} />
                </div>
                <div className={style.rightBox}>
                    <img src={rightImg} />
                </div>
                <div className={style.cardBox}>
                    {children}
                </div>
            </div>
        );
    }
}
